import React, { FC } from "react";
import Form from "react-bootstrap/Form";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import FormHelperText from "@mui/material/FormHelperText";
interface IInputSelect {
  controlId: string;
  label: string;
  placeholder: string;
  handleChange: any;
  handleBlur: any;
  errorsField: any;
  touched: any;
  value: any;
  options: any;
  readOnly?: any;
  disabled?: any;
  tabindex?:any;
}

/**
 * Input Type Text Reusable Component
 *
 * @param {{ controlId: any; label: any; placeholder: any; handleChange: any; handleBlur: any; errorsField: any; touched: any; }} {
    controlId, label, placeholder, handleChange, handleBlur, errorsField, touched, options, readOnly, disabled
}
 * @returns {*}
 */
const InputSelect: FC<IInputSelect> = ({
  controlId,
  label,
  placeholder,
  handleChange,
  handleBlur,
  errorsField,
  touched,
  value,
  options,
  readOnly,
  disabled,
  tabindex
}) => {
  return (
    <>
      {/*{ errorsField && touched ? "error" : ""}*/}

      <FormControl fullWidth error={errorsField && touched}>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          name={controlId}
          label={label}
          onChange={handleChange}
          onBlur={handleBlur}
          //tabIndex={tabindex ?tabindex:''}
          defaultValue={value}
          inputProps={{
            readOnly: Boolean(readOnly),
            disabled: Boolean(disabled),
            tabIndex: tabindex? tabindex :0
          }}>
          {options.map((options: any) => {
            return (
              <MenuItem key={options.key} value={options.key}>
                {options.value}
              </MenuItem>
            );
          })}
        </Select>


        {errorsField && touched ? <FormHelperText>{errorsField}  </FormHelperText> : ""}

      </FormControl>
    </>

    //<Form.Control.Feedback type="invalid">
    //             {errorsField}
    //         </Form.Control.Feedback>
    // <Form.Group className="mb-3 pb-1" controlId={controlId}>
    //     <Form.Label className="mb-1 text-uppercase fs-11 fw-bold label-color ls-small">{label}</Form.Label>
    //     <div className="position-relative">
    //         <Form.Control value={value} type="text" placeholder={placeholder} onBlur={handleBlur} onChange={handleChange} isInvalid={!!errorsField && touched} />
    //         <Form.Control.Feedback type="invalid">
    //             {errorsField}
    //         </Form.Control.Feedback>
    //     </div>
    // </Form.Group>
  );
};

export default InputSelect;
